module.exports = __webpack_public_path__ + "img/2-1.85f20d7d.svg";